import { ValidationError } from "@linempo/kernel";
import { annotationScenes, subtitleSelectionRange } from "@linempo/project-domain";
export function reconcileSelection(project, selection) {
    const cueIds = new Set(project.tracks.flatMap((track) => track._tag === "subtitles" ? track.cues.map((cue) => cue.id) : []));
    return {
        activeRegion: selection.activeRegion,
        assetIds: selection.assetIds.filter((id) => project.assets.some((asset) => asset.id === id)),
        assetId: project.assets.some((asset) => asset.id === selection.assetId) ? selection.assetId : null,
        clipId: annotationScenes(project).some((scene) => scene.id === selection.clipId) ? selection.clipId : null,
        cueIds: selection.cueIds.filter((id) => cueIds.has(id)),
        anchorCueId: selection.anchorCueId && cueIds.has(selection.anchorCueId) ? selection.anchorCueId : null,
    };
}
export function selectCueRange(project, selection, id, extend = false) {
    const track = project.tracks.find((track) => track._tag === "subtitles" && track.cues.some((cue) => cue.id === id));
    if (!track || track._tag !== "subtitles")
        throw new ValidationError({ path: "edit.selection", message: "字幕不存在。" });
    const end = track.cues.findIndex((cue) => cue.id === id);
    const anchor = extend ? track.cues.findIndex((cue) => cue.id === selection.anchorCueId) : -1;
    const start = anchor < 0 ? end : anchor;
    const ids = track.cues.slice(Math.min(start, end), Math.max(start, end) + 1).map((cue) => cue.id);
    subtitleSelectionRange(project, ids);
    return { cueIds: ids, anchorCueId: anchor < 0 ? id : selection.anchorCueId, timeMs: track.cues[end].startMs };
}
